import React, { useEffect, useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// import ImageSliderCard from "../ImageSliderCard";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import styles from './styles.module.css';

import SwiperCore from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import ImageSliderCard from '../ImageSliderCard';
SwiperCore.use([Navigation, Autoplay]);

export default function ImageSlider({ list, activeImage, setActiveImage }) {
  console.log('list', list);

  return (
    <>
      <div className={`${styles.imageSlider} `}>
        {/* <div className={` ${styles.showDesktop}`}> */}

        <Swiper
          breakpoints={{
            200: {
              slidesPerView: 3,
            },
            300: {
              slidesPerView: 4,
            },
            730: {
              slidesPerView: 5,
            },
            768: {
              slidesPerView: 4,
            },
            1024: {
              slidesPerView: 4,
            },
            1199: {
              slidesPerView: 4,
            },
            1300: {
              slidesPerView: 5,
            },
            1440: {
              slidesPerView: 5,
            },
            1600: {
              slidesPerView: 5,
            },
          }}
          pagination={false}
          navigation={true}
          spaceBetween={12}
          className="mySwiper imageMySwiper"
          // direction="vertical"
          allowTouchMove={true}
          // autoplay={{
          //   delay: 2500,
          //   pauseOnMouseEnter: true,
          //   disableOnInteraction: false,
          // }}
        >
          {list?.map((item, index) => (
            <SwiperSlide
              key={index}
              onClick={() => {
                setActiveImage(item);
              }}
              className={activeImage?.id == item?.id ? styles.border : styles.unActiveBorder}
            >
              {item && <ImageSliderCard src={item?.name} item={item} />}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {/* <div className={`${styles.imageSliderMobile}  ${styles.showMobile}`}>
        <Swiper
          breakpoints={{
            200: {
              slidesPerView: 2,
            },
            300: {
              slidesPerView: 2,
            },
            400: {
              slidesPerView: 3,
            },
            500: {
              slidesPerView: 4,
            },
            768: {
              slidesPerView: 5,
            },
            1024: {
              slidesPerView: 4,
            },
            1199: {
              slidesPerView: 4,
            },
            1600: {
              slidesPerView: 5,
            },
          }}
          pagination={false}
          navigation={true}
          className="mySwiper2"
          allowTouchMove={true}
          // autoplay={{
          //   delay: 2500,
          //   pauseOnMouseEnter: true,
          //   disableOnInteraction: false,
          // }}
        >
          {list?.map((item, index) => (
            <SwiperSlide
              key={index}
              onClick={() => {
                setActiveImage(item);
              }}
              className={activeImage?.id == item?.id && styles.border}
            >
              <ImageSliderCard src={item?.image?.name} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div> */}
    </>
  );
}
